<template>
	<QrcodeNavShell
		variant="outline"
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavShell from '../shared/QrcodeNavShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavOutline',
		components: { QrcodeNavShell },
		mixins: [qrcodeNavMixin],
	};
</script>
